<template>
    <div>
        <b-row>
            <b-col
                ><app-sub-title
                    text="Mensajes a puestos de trabajo operativos"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-btn
                    variant="primary"
                    @click="$router.push({ name: 'serviceSpotMessagesSend' })"
                    ><i class="fa fa-plus"></i> Enviar Mensaje</b-btn
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-service-spot-messages-filters @filter="onFilter" />
            </b-col>
        </b-row>
        <b-row>
            <b-col
                ><app-service-spot-messages-list
                    v-bind="messages"
                    @changePage="onChangePage"
            /></b-col>
        </b-row>
        <b-row>
            <b-col></b-col>
        </b-row>
    </div>
</template>
<script>
import appServiceSpotMessagesFilters from './ServiceSpotMessagesFilters'
import appServiceSpotMessagesList from './ServiceSpotMessagesList'
export default {
    components: {
        appServiceSpotMessagesFilters,
        appServiceSpotMessagesList,
    },
    data: () => ({
        messages: [],
        filters: {},
        page: 1,
        sortBy: 'service_spot_messages.created_at',
        sortDir: 'desc',
    }),
    computed: {},
    methods: {
        async loadServiceSpotMessages() {
            const { data } = await repo.get('service-spot-messages', {
                ...this.filters,
                userId: this.user.id,
                with: 'createdBy:users.id,users.name',
                page: this.page,
            })
            const tableData = {}
            _.forIn(
                data,
                (value, key) =>
                    (tableData[
                        _.kebabCase(key === 'data' ? 'items' : key)
                    ] = value)
            )
            this.messages = tableData
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadServiceSpotMessages()
        },
        onChangePage(page) {
            this.page = page
            this.loadServiceSpotMessages()
        },
    },
    mounted() {
        this.loadServiceSpotMessages()
    },
}
</script>
